import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Button from 'yoda-core-components/lib/components/Button/Button';
import { selectFeatureFlags } from '../../selectors/ContextSelector';
import CouponUtilsHelper from '../CouponList/CouponUtilsHelper';
import { COUPON_APPLED_METHOD_SELECT_COUPON } from '../../common/Constants';
import adjustmentActions from '../../actions/AdjustmentAction';

const CMCouponApplyRemove = (props) => {
    const { couponData, couponID, isAdjustmentApplied, featureFlags, bagItemCount } = props;
    const { promoCode, redeemingChannel } = couponData;
    const componentCTABtnStyle = dt([
        'inline',
        'w-auto',
        'min-w-[240px]',
        'text-base',
        'leading-6',
        'px-2',
        'rounded-lg',
    ]);

    /* istanbul ignore else */
    const onApplyCoupon = (featureFlags, promoCode) => {
        const applyingToEmptyCart = featureFlags && featureFlags.Coupon_AllowApplyEmptyCart;

        if (bagItemCount > 0 || applyingToEmptyCart) {
            props.actions.applyAdjustment({
                code: props.couponData?.promoCode?.trim(),
                serialNumber: null,
                method: COUPON_APPLED_METHOD_SELECT_COUPON,
                slot: props.couponSlot,
                category: props.couponData?.redeemingChannel,
                couponAnimation: false,
                selectedCouponCode: promoCode,
            });
            props?.getCurrentAppliedCode(promoCode);
            props?.setApplyBtnClicked(true);
        }
    };

    /* istanbul ignore else */
    const onRemoveCoupon = (selectedCouponCode, couponID) => {
        props.actions.removeAdjustmentById(couponID, false, selectedCouponCode);
        const [couponAppledNum] = CouponUtilsHelper.getSavedPromoCodeValues();
        if (couponAppledNum) CouponUtilsHelper.removePromoCode();
    };

    return (
        <div>
            {promoCode && redeemingChannel !== 'instore' && (
                <Button
                    className={componentCTABtnStyle}
                    automationId="code-apply"
                    buttonType={isAdjustmentApplied ? 'Secondary' : 'Primary'}
                    size="Md"
                    type="button"
                    onClick={() =>
                        isAdjustmentApplied
                            ? onRemoveCoupon(promoCode, couponID)
                            : onApplyCoupon(featureFlags, promoCode)
                    }
                >
                    {isAdjustmentApplied ? `Remove Code: ${promoCode}` : `Apply Code: ${promoCode}`}
                </Button>
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    featureFlags: selectFeatureFlags(state),
    bagItemCount: state.bagItemCount,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(Object.assign(adjustmentActions), dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CMCouponApplyRemove);
